import { driveClient, saveVaultLink, uploadToHive } from '@/data/vault';
import { compressImage } from '@/lib/images';
import { supabase } from '@/lib/supabase';
import type { UploadDeps } from './upload';

/** What uploads use for real: Drive, Hive storage, image compression, and attaching through links. */
export const liveDeps: UploadDeps = {
  drive: driveClient,
  saveLink: saveVaultLink,
  toHive: uploadToHive,
  compress: compressImage,
  link: async (from, to) => {
    const { error } = await supabase()
      .from('links')
      .insert({ from_type: from.type, from_id: from.id, to_type: to.type, to_id: to.id, kind: 'attached' });
    if (error && error.code !== '23505') throw error;
  },
};
